import React, { useState } from "react";
import PropTypes from "prop-types";
import ArrowDown from "../../../assets/images/svg/ic_keyboard_arrow_down_24px.svg";
import ArrowUp from "../../../assets/images/svg/ic_keyboard_arrow_up_24px.svg";
import StandardMoney from "../../common/StandardMoney";

const AccordionPanel = ({
  intl,
  subTotal,
  records,
  subHeader,
  currency,
  color,
  hideCurrency = false,
  isUnlimited = false,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <div>
        <span className="multiline-span">
          {intl.formatMessage({
            id: subHeader,
            defaultMessage: subHeader,
          })}
        </span>
        {open ? (
          <ArrowUp style={{ float: "right" }} onClick={() => setOpen(!open)} />
        ) : (
          <ArrowDown style={{ float: "right" }} onClick={() => setOpen(!open)} />
        )}
        <span
          className="field__currency payment__price"
          style={subTotal < 0 ? { float: "right", color: color || "red" } : { float: "right" }}
        >
          <StandardMoney
            value={subTotal}
            currency={!hideCurrency ? currency : null}
            isUnlimited={isUnlimited}
          />
        </span>
      </div>
      <div className="accordion-panel-container" style={{ display: open ? "block" : "none" }}>
        <table className="accordion-panel-table">
          {records.map((record, idx) => {
            const { transactionType, actualAmount } = record;
            const labelText = intl.formatMessage({
              id: transactionType,
              defaultMessage: transactionType,
            });
            return (
              actualAmount != 0 && (
                <tr key={idx}>
                  <td className="benefit-name">{labelText}</td>
                  <td className="benefit-price">
                    <span
                      className="field__currency"
                      style={actualAmount < 0 ? { color: color || "red" } : {}}
                    >
                      <StandardMoney
                        value={actualAmount}
                        currency={!hideCurrency ? currency : null}
                        isUnlimited={isUnlimited}
                      />
                    </span>
                  </td>
                </tr>
              )
            );
          })}
        </table>
      </div>
    </div>
  );
};

AccordionPanel.propTypes = {
  intl: PropTypes.object.isRequired,
  subTotal: PropTypes.number.isRequired,
  records: PropTypes.array.isRequired,
  subHeader: PropTypes.string.isRequired,
  panelId: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  hideCurrency: PropTypes.bool,
  isUnlimited: PropTypes.bool,
  color: PropTypes.string,
};

export default AccordionPanel;



// WEBPACK FOOTER //
// ./components/claim/widgets/AccordionPanel.jsx